import moment from 'moment';

// Utility function to format a date using moment.js
export const formatDate = (date, format) => {
  if (!date) return ''; // Handle empty dates if needed
  if (!format)
    format = process.env.REACT_APP_DefaultDateFormat
  return moment(date).format(format);
};
export default formatDate;

export const format_Date = (date) => {
  if (!date) return null;

  const d = (date instanceof Date) ? date : new Date(date);

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};


export const dateFormatOfGroupHeaderTemplate = (label) => (row, cfg) => {
  const field = cfg.props.groupRowsBy;
  const value = row[field];

  const count = cfg.props.value.filter(
    (e) => e[field] === value
  ).length;

  return (
    <span>
      {label}: {format_Date(value)} ({count})
    </span>
  );
};
